import { ROLE } from '@trace-8/trace8-schema';
export const tenantsTableColumns = [
  { title: 'Name', key: 'NAME', width: 35, keySort: 'name' },
  { title: 'Primary Admin', key: 'PRIMARY_ADMIN', width: 25, keySort: 'primary admin' },
  { title: '', key: null, width: 40, keySort: '' }
];

export const reportingTypesEnumMap = {
  tamarac: 'Tamarac',
  blackdiamond: 'Black Diamond'
};

export { ROLE };
